var Theme = Theme || {};

Theme.RegisterUser = (function ($) {
    var $formContainer = $('.widget-RegisterUser');
    var emailInvalidMessage = $formContainer.find('#ErrorMessageEmailAddress').data('invalidMessage');

    var $extendedPasswordRequirementsControl = $('#extendedPasswordRequirementsEnabled');
    if ($extendedPasswordRequirementsControl.length && $extendedPasswordRequirementsControl.val() === 'True') {
        SCM.MyAccount.initTestPasswordWithExtendedRequirements();
    }
    else {
        SCM.MyAccount.initTestPassword();
    }

    return {
        init: _init
    };

    function _init() {
        showPassword();
        hidePassword();
        updateStatesDropdownOnCountrySelection();
        validateEmailOnBlur();
        registerNewUser();
    }

    function validateEmailOnBlur() {
        $formContainer.on('focusout', '#EmailAddress', function () {
            var email = $(this).val();
            if (email.length === 0) {
                _hideEmailError();
                return;
            }
            if (!SCM.JSUtility.isValidEmail(email)) {
                _showEmailError();
            } else {
                _hideEmailError();
            }
        });

        $formContainer.on('input', '#EmailAddress', function () {
            if ($(this).attr('aria-invalid') !== 'true') {
                return;
            }

            var email = $(this).val();
            if (email.length === 0 || SCM.JSUtility.isValidEmail(email)) {
                _hideEmailError();
            }
        });
    }

    function _showEmailError() {
        $formContainer.find('#ErrorMessageEmailAddress').html(emailInvalidMessage).removeClass('hide');
        $formContainer.find('#EmailAddress').attr('aria-invalid', 'true');
    }

    function _hideEmailError() {
        $formContainer.find('#ErrorMessageEmailAddress').addClass('hide').html('');
        $formContainer.find('#EmailAddress').removeAttr('aria-invalid');
    }

    function showPassword() {
        $formContainer.on('click', '#showPassword', function () {
            $formContainer.find('#Password, #ConfirmPassword').each(function () {
                var $newInput = $(this).clone();
                $newInput.attr('type', 'text');
                $newInput.attr('autocomplete', 'off');
                $newInput.attr('value', $(this).val());

                $(this).after($newInput);
                $(this).remove();
            });

            $(this).hide();
            $(this).siblings('#hidePassword').show();
        });
    }

    function hidePassword() {
        $formContainer.on('click', '#hidePassword', function () {
            $formContainer.find('#Password, #ConfirmPassword').each(function () {
                var $newInput = $(this).clone();
                $newInput.attr('type', 'password');
                $newInput.removeAttr('autocomplete');
                $newInput.attr('value', $(this).val());

                $(this).after($newInput);
                $(this).remove();
            });

            $(this).hide();
            $(this).siblings('#showPassword').show();
        });
    }

    function updateStatesDropdownOnCountrySelection() {
        $formContainer.on('change', '#CountryList', function () {
            _loadCountryStates($formContainer);
        });
    }

    function registerNewUser() {
        $formContainer.on('click', '#registerBtn', _handleRegisterButtonClick);
    }

    function _handleRegisterButtonClick() {
        var $button = $formContainer.find('#registerBtn');
        if ($button.hasClass('disabled')) {
            return;
        }

        $('.error-message').addClass('hide');

        var email = $formContainer.find('#EmailAddress').val();
        if (email.length > 0 && !SCM.JSUtility.isValidEmail(email)) {
            _showEmailError();
            return;
        }

        var userName = $formContainer.find('#UserName').val();
        var password = $formContainer.find('#Password').val();
        var confirmPassword = $formContainer.find('#ConfirmPassword').val();
        var title = $formContainer.find('#Title').val();
        var firstName = $formContainer.find('#FirstName').val();
        var lastName = $formContainer.find('#Lastname').val();
        var membershipNumber = $formContainer.find('#MembershipNumber').val();
        var vendorId = $formContainer.find('#VendorId').val();
        var address = $formContainer.find('#Address').val();
        var city = $formContainer.find('#City').val();
        var stateList = $formContainer.find('#StateList').val();
        var countryList = $formContainer.find('#CountryList').val();
        var zipCode = $formContainer.find('#ZipCode').val();
        var telephone = $formContainer.find('#Telephone').val();
        var faxnumber = $formContainer.find('#Fax').val();
        var mobileNumber = $formContainer.find('#Mobile').val();
        var termsAccepted = $formContainer.find('#TermsOfUseAcceptance').is(':checked');
        var privacyAccepted = $formContainer.find('#PrivacyPolicyAcceptance').is(':checked');
        var marketingAccepted = $formContainer.find('#MarketingAcceptance').is(':checked');
        var templist = _getCfdValue();
   
        var userInfo = {
            'UserName': userName,
            'EmailAddress': email,
            'Password': password,
            'ConfirmPassword': confirmPassword,
            'Title': title,
            'FirstName': firstName,
            'Lastname': lastName,
            'MembershipNumber': membershipNumber,
            'VendorId': vendorId,
            'Address': address,
            'City': city,
            'State': stateList,
            'Country': countryList,
            'ZipCode': zipCode,
            'PhoneNumber': telephone,
            'MobileNumber': mobileNumber,
            'FaxNumber': faxnumber,
            'ClientFieldDefinitionList': templist,
            'TermsOfUseAccepted': termsAccepted,
            'PrivacyPolicyAccepted': privacyAccepted,
            'ReceivesMarketingEmailAlert': marketingAccepted,
            'CaptchaResponse': SCM.Captcha.GetCaptchaResponse($formContainer),
            'CaptchaWidgetInstanceName': SCM.Captcha.GetCaptchaInfo().ReCaptchaWidgetControlId
        };
      
        var ajaxUrl = '/UserDashboard/RegisterNewUser';

        $button.prop('disabled', true).addClass('disabled is-processing');

        SCM.Ajax.post(ajaxUrl, userInfo)
            .expectActionResultModel()
            .ensureSuccess()
            .then(_handleRegisterSuccess)
            .catch(_handleRegisterError);
    }

    function _handleRegisterSuccess(result) {
        if (SCM.GoogleTagManagerDataLayerEvents) {
            var returnUrl = SCM.SiteJS.getDefaultReturnUrl();
            SCM.GoogleTagManagerDataLayerEvents.logSuccessfulAction(returnUrl,'', 'register');
        }
        if (result.Data && result.Data.ReplaceRegisterForm)
        {
            $('.register-form-content').hide();
            $('.js-email-verification-message').html(result.Data.VerificationEmailSent);
        }
        else
        {
            SCM.SiteJS.loginReturnBack();
        }
    }
       
    function _handleRegisterError(ajaxError) {
        $formContainer.find('#registerBtn').prop('disabled', false).removeClass('disabled is-processing');

        var actionResult = ajaxError.actionResultModel;

        if (actionResult.ValidationErrors?.length) {
            $.each(actionResult.ValidationErrors, function (index, value) {
                $formContainer.find(`#ErrorMessage${value.Key}`)
                    .removeClass('hide')
                    .html(value.Errors.join(' '));

                $(`#${value.Key}`).attr('aria-invalid', 'true');
            });
        }

        if (actionResult.Messages?.length) {
            var $ulObj = $('<ul></ul>');
            var $errorMsgDiv = $formContainer.find('.at-errormessages');

            $.each(actionResult.Messages, function (index, value) {
                $ulObj.append(`<li>${value}</li>`);
            });

            $errorMsgDiv.html($ulObj).removeClass('hide');
        }

        SCM.Captcha.ResetCaptcha($formContainer);
    }

    function _loadCountryStates(formContainer) {
        var countryId = formContainer.find('#CountryList').val();
        var stateList = formContainer.find('#StateList');
        stateList.empty().prop('disabled', true);
        if (countryId != undefined && countryId.length) {
            var ajaxUrl = '/UserDashboard/RegisterGetCountryStates';
            var ajaxData = { 'countryId': countryId };

            SCM.Ajax.get(ajaxUrl, ajaxData)
                .expectJson()
                .then(_renderStateOptions)
                .catch(console.error);
        }
    }

    function _renderStateOptions(ajaxResult) {
        var stateList = $formContainer.find('#StateList');
        if (ajaxResult != undefined && ajaxResult.length) {
            $.each(ajaxResult, function (_index, value) {
                stateList.append($(`<option value="${value.StateId}">${value.StateName}</option>`));
            });
            stateList.prop('disabled', false);
        }
    }

    function _getCfdValue() {
        var $formContainer = $('.widget-RegisterUser');
        var cfdlist = $formContainer.find('.js-fieldList');
        var list = [];
        if (cfdlist.length > 0) {
            cfdlist.each(function () {
                var cfdId = $(this).attr('data-cfdId');
                var cfdvalue = $(this).val();
                list.push({ 'ClientFieldDefinitionId': cfdId, 'SpecifiedFieldValue': cfdvalue });
            });
        }
        return list;
    }

})(jQuery);